"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createReactDOMStyle = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet/compiler/createReactDOMStyle"));
var _prefixStyles = _interopRequireDefault(require("react-native-web/dist/cjs/modules/prefixStyles"));
var _hyphenateStyleName = _interopRequireDefault(require("./hyphenate-style-name"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const createDeclarationBlock = style => {
  const domStyle = (0, _prefixStyles.default)((0, _createReactDOMStyle.default)(style));
  const declarationsString = Object.keys(domStyle).map(property => {
    const value = domStyle[property];
    const prop = (0, _hyphenateStyleName.default)(property);
    if (Array.isArray(value)) {
      return value.map(v => `${prop}:${v}`).join(';');
    }
    return `${prop}:${value} !important`;
  }).sort().join(';');
  return `{${declarationsString};}`;
};
var _default = exports.default = createDeclarationBlock;